import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "7720ddf8-fc35-40ca-8e06-b815bea59812",
    content: "The diaphragm vibrates at twice the excitation frequency",
    options: {},
  },
  {
    id: "d2e0ffa2-7ce0-4408-8f0a-06002ab24fb7",
    content: "the diaphragm vibrates at half the excitation frequency",
    options: {},
  },
  { id: "f98bb33b-9738-4b27-9195-0cfaecd9ffb6", content: "The diaphragm does not vibrate", options: {} },
  {
    id: "5d8d60dd-fcd6-44ef-a6a2-91d2a703d0e1",
    content: "The diaphragm vibrates at the excitation frequency",
    options: {},
  },
];

export const task: Task = {
  id: "52bbbd46-91cc-4fa7-9c76-4fafa9206d91",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["7720ddf8-fc35-40ca-8e06-b815bea59812"],
};
